class BookingOverlay extends HTMLElement {
  constructor() {
    super();

    this.openToggle = this.openToggle.bind(this);

    this.opneCloseToggles = this.querySelectorAll(
      ".booking-overlay__open-close-toggle"
    );

    this.opneCloseToggles.forEach((toggle) => {
      toggle.addEventListener("click", this.openToggle);
    });

    this.submitButton = this.querySelector("input[type='submit']");

    this.submitButton.addEventListener("click", (e) => {
      console.log(
        "submit - booking form",
        this.querySelector(".overlay__inner").style.minHeight,
        this.querySelector(".overlay__inner").offsetHeight
      );
      this.querySelector(".overlay__inner").style.minHeight =
        this.querySelector(".overlay__inner").offsetHeight + "px";
      this.querySelector(".overlay__inner").classList.add("submitted");
    });
  }

  openToggle() {
    this.classList.toggle("open");
    this.querySelector(".overlay")?.classList.toggle("open");
  }
}

customElements.define("booking-overlay", BookingOverlay);
